import React from 'react';

const PageHeader = ({ title, description, icon }) => {
    return(
        <div className="PageHeader row ptb-2">
            <div className="col-lg-12 p-0 align-content-center">
                <h4 className="d-flex">{title || ``}{icon && icon}</h4>
                {description && <h6>{description}</h6>}
            </div>
        </div>
    )
}

export default PageHeader;